import { useAcademy } from '../../../middleware/useAcademy';
import { useBadges } from '../../../middleware/useBadges';
import { BadgeNotification } from './BadgeNotification';

/**
 * Provider component that watches for badge changes and displays notifications
 * This should be placed high in the component tree to be available app-wide
 */
export function BadgeNotificationProvider() {
  // Get user badges from the academy context
  const { badges: userBadges } = useAcademy();

  // Use our badge hook to get badge status
  const { badgesWithEarnedStatus } = useBadges(userBadges);

  return (
    <BadgeNotification
      earnedBadges={badgesWithEarnedStatus}
      userBadges={userBadges}
    />
  );
}
